import styles from "../floorplans.module.scss";

export default function CommunityCostGuide({ data }) {
  const costGuideData = data?.community_cost_guide;
  
  // Only render if title or iframe_url is available
  if (!costGuideData || (!costGuideData.community_cost_guide_title && !costGuideData.iframe_url)) {
    return null;
  }
  
  return (
    <div className={styles.communityCostGuide} id="community-cost-guide">
      {costGuideData.community_cost_guide_title && (
        <h2 dangerouslySetInnerHTML={{ __html: costGuideData.community_cost_guide_title }}></h2>
      )}
      {costGuideData.community_cost_guide_description && (
        <p dangerouslySetInnerHTML={{ __html: costGuideData.community_cost_guide_description }} />  
      )}
      
      {costGuideData.iframe_url && (
        <div className={styles.costIframe}>
          <div style={{
            position: 'relative',
            width: '100%',
            height: 0,
            paddingTop: '129.4118%',
            paddingBottom: 0,
            boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)',
            marginTop: '1.6em',
            marginBottom: '0.9em',
            overflow: 'hidden',
            borderRadius: '8px',
            willChange: 'transform'
          }}>
            <iframe 
              loading="lazy" 
              style={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                border: 'none',
                padding: 0,
                margin: 0
              }} 
              src={costGuideData.iframe_url} 
              allowFullScreen="allowfullscreen" 
              allow="fullscreen"
            />
          </div>
        </div>
      )}
    </div>
  );
}
